import React from 'react';

const STROKE = 3.25;
const BLUE_OUTLINE = 'currentColor';
/** Remplissage aiguille (réf. #adc8ff) */
const FILL_LIGHT = '#adc8ff';
const FILL_ON_DARK = 'rgba(255, 255, 255, 0.52)';

/**
 * Logo jauge / compteur (reproduction SVG de la charte fournie).
 * - variant="default" : contours en currentColor, remplissage aiguille #adc8ff
 * - variant="onPrimary" : contours blancs (hero / fond bleu)
 */
export default function BarometreLogo({
  className = 'h-10 w-10',
  title = 'Baromètre Social',
  decorative = false,
  variant = 'default',
  ...rest
}) {
  const outline = variant === 'onPrimary' ? '#ffffff' : BLUE_OUTLINE;
  const needleFill = variant === 'onPrimary' ? FILL_ON_DARK : FILL_LIGHT;

  const cx = 50;
  const cy = 50;
  const rArc = 30;
  const rad = (d) => (d * Math.PI) / 180;
  const px = (a) => cx + rArc * Math.cos(rad(a));
  const py = (a) => cy + rArc * Math.sin(rad(a));
  const p1x = px(120);
  const p1y = py(120);
  const p2x = px(60);
  const p2y = py(60);

  /* 7 repères, espacement régulier sur l’arc majeur (120° → 60°, +300°) */
  const tickDeg = [120, 170, 220, 270, 320, 10, 60];
  const tickInner = 22;
  const tickOuter = 28.5;

  /* Aiguille ~1 h : direction (sin30°, -cos30°), pivot bas-centre */
  const hx = 50;
  const hy = 75;
  const dirX = 0.5;
  const dirY = -0.8660254;
  const perpX = 0.8660254;
  const perpY = 0.5;
  const halfW = 4.85;
  const needleLen = 37;
  const leftX = hx - perpX * halfW;
  const leftY = hy - perpY * halfW;
  const rightX = hx + perpX * halfW;
  const rightY = hy + perpY * halfW;
  const tipX = hx + dirX * needleLen;
  const tipY = hy + dirY * needleLen;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={`shrink-0 ${className}`}
      role={decorative ? 'presentation' : 'img'}
      aria-hidden={decorative ? true : undefined}
      aria-label={decorative ? undefined : title}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {!decorative ? <title>{title}</title> : null}

      <circle cx={cx} cy={cy} r={46} stroke={outline} strokeWidth={STROKE} />

      <path
        d={`M ${p1x} ${p1y} A ${rArc} ${rArc} 0 1 1 ${p2x} ${p2y}`}
        stroke={outline}
        strokeWidth={STROKE}
      />

      <g stroke={outline} strokeWidth={STROKE}>
        {tickDeg.map((deg) => {
          const r0 = rad(deg);
          const x1 = cx + tickOuter * Math.cos(r0);
          const y1 = cy + tickOuter * Math.sin(r0);
          const x2 = cx + tickInner * Math.cos(r0);
          const y2 = cy + tickInner * Math.sin(r0);
          return <line key={`tick-${deg}`} x1={x1} y1={y1} x2={x2} y2={y2} />;
        })}
      </g>

      <path
        d={`M ${leftX} ${leftY} L ${tipX} ${tipY} L ${rightX} ${rightY} Z`}
        fill={needleFill}
        stroke={outline}
        strokeWidth={STROKE * 0.88}
        strokeLinejoin="round"
      />
      <circle
        cx={hx}
        cy={hy}
        r={5.35}
        fill={needleFill}
        stroke={outline}
        strokeWidth={STROKE * 0.88}
      />
    </svg>
  );
}
